import type { KnownApiError_ConfiguratorError } from "src/api/generated/errors/knownApiError.ts";
import type { JsonObject } from "src/components/views/ai/assistant/uiContext/jsonTypes.ts";

export function configuratorErrorAgentData(error: KnownApiError_ConfiguratorError): JsonObject {
	return {
		type: error.type,
		errorContextId: error.errorContextId,
		sessionId: error.sessionId,
		isTestConfigurator: error.isTestConfigurator,
		base64LogPath: error.base64LogPath,
	};
}
